import { config } from "@/config";
import { Provider } from "@/providers/http.provider";
import type { RateCard, RateCardWithItems } from "@rebuild/shared";

interface GetRateCardsResponse {
  success: boolean;
  data?: RateCard[];
  error?: string;
}

interface GetRateCardResponse {
  success: boolean;
  data?: RateCardWithItems;
  error?: string;
}

class RateCardProvider extends Provider {
  constructor() {
    super({
      baseURL: `${config.baseAPIUrl}/rest/rate-cards`,
    });
  }

  async getRateCards(): Promise<RateCard[]> {
    const response = await super.get<GetRateCardsResponse>("");
    if (!response.success) {
      throw new Error(response.error || "Failed to fetch rate cards");
    }
    return response.data ?? [];
  }

  async getRateCard(rateCardId: string): Promise<RateCardWithItems> {
    const response = await super.get<GetRateCardResponse>(rateCardId);
    if (!response.success || !response.data) {
      throw new Error(response.error || "Failed to fetch rate card");
    }
    return response.data;
  }
}

export default new RateCardProvider();
